/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import OrderCreateOrderItemParam from './OrderCreateOrderItemParam';

/**
 * The OrderUpdateOrderParam model module.
 * @module model/OrderUpdateOrderParam
 * @version 1.0
 */
class OrderUpdateOrderParam {
    /**
     * Constructs a new <code>OrderUpdateOrderParam</code>.
     * @alias module:model/OrderUpdateOrderParam
     */
    constructor() { 
        
        OrderUpdateOrderParam.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>OrderUpdateOrderParam</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/OrderUpdateOrderParam} obj Optional instance to populate.
     * @return {module:model/OrderUpdateOrderParam} The populated <code>OrderUpdateOrderParam</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new OrderUpdateOrderParam();

            if (data.hasOwnProperty('date')) {
                obj['date'] = ApiClient.convertToType(data['date'], 'String');
            }
            if (data.hasOwnProperty('items')) {
                obj['items'] = ApiClient.convertToType(data['items'], [OrderCreateOrderItemParam]);
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'String');
            }
            if (data.hasOwnProperty('userId')) {
                obj['userId'] = ApiClient.convertToType(data['userId'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {String} date
 */
OrderUpdateOrderParam.prototype['date'] = undefined;

/**
 * @member {Array.<module:model/OrderCreateOrderItemParam>} items
 */
OrderUpdateOrderParam.prototype['items'] = undefined;

/**
 * @member {String} status
 */
OrderUpdateOrderParam.prototype['status'] = undefined;

/**
 * @member {Number} userId
 */
OrderUpdateOrderParam.prototype['userId'] = undefined;






export default OrderUpdateOrderParam;

